module.exports = __webpack_public_path__ + "img/CUADRO_Esp-Tecnicas-RKU10.97cae784.png";